import React from 'react';

import { Divider } from '@infoods/lifebase-ui';
import { Skeleton } from '@mui/material';

import classes from './PaymentDetailsCell.module.scss';
import { PaymentDetailInfo } from '../../../../interfaces/paymentDetails';
import { PriceLabelRow } from '../PriceLabelRow/PriceLabelRow';

type PaymentDetailsCellProps = {
  showDivider?: boolean;
  paymentDetail?: PaymentDetailInfo;
  isLoading?: boolean;
};

const PaymentDetailsCell = ({
  paymentDetail,
  isLoading,
  showDivider,
}: PaymentDetailsCellProps) => {
  const isShowSkeleton = isLoading || !paymentDetail;

  return (
    <div>
      {isShowSkeleton ? (
        <Skeleton width="100%" height="30px" />
      ) : (
        <>
          <PriceLabelRow label={paymentDetail.label} value={paymentDetail.value} />
          <div className={classes.descriptionRow}>{paymentDetail.description}</div>
        </>
      )}
      {showDivider && <Divider className={classes.divider} />}
    </div>
  );
};
export { PaymentDetailsCell };
